import { VideoAdsQuizQuestion } from "./video-ads-quiz.types";

export const getQuestionsAnsweredCount = (
  videoAdsQuiz: VideoAdsQuizQuestion[]
) => {
  return videoAdsQuiz.filter((question) => {
    return question.answer;
  }).length;
};

export const setQuestionAnswer = (
  currentQuestion: VideoAdsQuizQuestion,
  selectedId: string
) => {
  return {
    ...currentQuestion,
    options: currentQuestion.options.map((option) => ({
      ...option,
      isSelected: option.id === selectedId,
    })),
    answer: true,
  };
};

export const isQuestionCorrect = (questionAnswered: VideoAdsQuizQuestion) => {
  return questionAnswered.options.find(
    (option) => option.isSelected && option.isCorrect
  );
};
